import { v4 as uuidv4 } from 'uuid';

/**
 * Идентичность «факта открытия карточки документа». Document НЕ перемонтируется при смене :id
 * (refs/redux переживают навигацию), поэтому каждый async-резолв, пишущий в общий ref/redux,
 * обязан убедиться, что это всё ещё ТЕКУЩЕЕ открытие.
 *
 * Две сущности с РАЗНЫМ временем жизни (их нельзя свести к одной — у них несовместимые требования):
 *  - openToken (persistent) — гард async-резолвов: должен пережить ВСЁ открытие, иначе поздний
 *    легитимный резолв того же открытия забэйлился бы;
 *  - backendGuid (short-lived) — группировка пачки запросов под кэш прав на бэке. Бэк кэширует
 *    маску доступа по guid с абсолютным TTL 15с (DocumentAccessChecker.cs). Отдаём guid только
 *    первые 10с открытия (недобор под 15с): поздние запросы (realtime-refetch действий, late
 *    статус-бар) уходят БЕЗ guid → бэк пересчитывает права заново, а не отдаёт маску, посчитанную
 *    на момент открытия (иначе после продвижения маршрута тулбар залипал бы на устаревших правах).
 *
 * Гарды не на токене (структурно не подходит): titleBarActions — per-request seq (порядок СРЕДИ
 * запросов ОДНОГО открытия: T=0-фетч vs catchup-refresh); checkDraft — pathname (его гонка только
 * для НОВОГО документа).
 */
const BACKEND_GUID_TTL_MS = 10_000;

let openToken = 0;
let backendGuid: string | undefined;
let openedAtMs = 0;

/** Начать открытие: ротировать токен-гард и сгенерировать свежий backend-guid. Возвращает guid. */
export const beginDocumentOpen = (): string => {
    openToken++;
    backendGuid = uuidv4();
    openedAtMs = Date.now();
    return backendGuid;
};

/** Токен текущего открытия — захватывается резолвом на входе для последующей сверки. */
export const getCurrentOpenToken = (): number => openToken;

/** Совпадает ли захваченный токен с текущим открытием — гард перед записью в ref/redux/state. */
export const isCurrentOpen = (token: number): boolean => token === openToken;

/** Backend-guid группировки прав, пока не истёк 10с-лимит; иначе undefined → бэк считает заново. */
export const getCurrentOpenGuid = (): string | undefined =>
    backendGuid !== undefined && Date.now() - openedAtMs < BACKEND_GUID_TTL_MS ? backendGuid : undefined;
